// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".adminusers {\n    \n}\n\n.adminusers-table {\n    margin: 10px;\n\tborder-radius: 5px;\n\tbox-shadow: 0 0 5px #dedede;\n}", ""]);
// Exports
module.exports = exports;
